module.exports = __webpack_public_path__ + "media/images/partners/ibm-4cc96453fd059633b5933d08edf2d668.svg";